import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';

import { CREATOR_ACTION_BAR_Z_INDEX } from '../../utils/constants';

export const CreatorActionBarStyled = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: ${CREATOR_ACTION_BAR_Z_INDEX};
  background: ${rgba(theme.colors.gray['800'] as string, 0.9)};
`;

export const BottomSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${rem('60px')};
`;

export const NavSection = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${rem('20px')};
`;

export const ActionsSection = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${rem('16px')};
`;
